module.exports = __webpack_public_path__ + "img/CTG.6d251430.png";